import { createTheme, darken } from '@mui/material/styles'

export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#F78F1E',
        },
        secondary: {
            main: '#0078A4',
        },
        action: {
            active: 'rgba(255, 255, 255, 0.56)',
            selected: 'rgba(255, 255, 255, 0.16)',
            hover: 'rgba(255, 255, 255, 0.08)',
            focus: 'rgba(255, 255, 255, 0.12)',
            disabled: 'rgba(255, 255, 255, 0.30)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
        },
        background: {
            default: '#4D4D4D',
            paper: '#4D4D4D',
        },
        warning: {
            main: '#FFCC00',
        },
        divider: '#E6E6E6',
    },
    typography: {
        fontFamily: "'Roboto Variable', sans-serif",
        strong1: {
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: 1.5,
            letterSpacing: '0.00938em',
        },
        strong2: {
            fontWeight: 700,
            fontSize: '0.875rem',
            lineHeight: 1.43,
            letterSpacing: '0.01071em',
        },
        small: {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 1.2,
            letterSpacing: '0.0125em',
        },
        inputTextSmall: {
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: 1.5,
            letterSpacing: '0.0125em',
        },
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiFormControl: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    color: '#FFFFFF',
                },
                primary: {
                    color: '#FFFFFF',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    backgroundColor: '#4D4D4D',
                },
            },
        },
        MuiCardActionArea: {
            styleOverrides: {
                focusHighlight: {
                    backgroundColor: darken('#E9ECEF', 0.5),
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '8px',
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    strong1: 'p',
                    strong2: 'p',
                    small: 'p',
                    inputTextSmall: 'p',
                },
            },
        },
    },
})
